
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 2h-3V1a1 1 0 00-1-1h-3a1 1 0 00-1 1v1h-3a1 1 0 00-1 1v1a1 1 0 00.999 1h11.002a1 1 0 00.999-1V3a1 1 0 00-1-1zm-4 0h-3v-.5A.5.5 0 017 1h2a.5.5 0 01.5.5V2zm-7 12a2 2 0 002 2h7a2 2 0 002-2V6h-11v8zM10 7.5a.5.5 0 011 0v6a.5.5 0 01-1 0v-6zm-2.5 0a.5.5 0 011 0v6a.5.5 0 01-1 0v-6zM5 7.5a.5.5 0 011 0v6a.5.5 0 01-1 0v-6z","fill":"#fff"}})])
          )
        }
      }
    